module.exports = __webpack_public_path__ + "fa-regular-400.491a96d8188670aff6f5.eot";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-regular-400.eot
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-regular-400.eot
// module chunks = styles